$(document).ready(function () {
  // Gray bar at trhe very top of the header. Communicates value offered by cerascreen

  if ($("#valueBar .splide").length) {
    new Splide("#valueBar .splide", {
      perPage: 6,
      width: "100%",
      destroy: true,
      autoplay: true,
      breakpoints: {
        1259: {
          type: "loop",
          perPage: 3,
          perMove: 3,
          focus: "center",
          trimSpace: false,
          autoplay: true,
          interval: 3000,
          pauseOnHover: false,
          arrows: false,
          pagination: false,
          drag: false,
        },
        990: {
          type: "loop",
          perPage: 1,
          perMove: 1,
          focus: "center",
          trimSpace: false,
          width: "100%",
          autoplay: true,
          interval: 3000,
          pauseOnHover: false,
          arrows: false,
          pagination: false,
          drag: false,
        },
      },
    }).mount();
  }

  // Contrast bar (orange) above navigation. Promo message

  if ($("#promoBar .splide").length) {
    var splide = new Splide("#promoBar .splide", {
      width: "100%",
      autoplay: true,
      type: "loop",
      perPage: 1,
      perMove: 1,
      focus: "center",
      trimSpace: false,
      interval: 3000,
      pauseOnHover: false,
      arrows: false,
      pagination: false,
    }).mount();

    $("#promoBar .slide-prev").click(function () {
      splide.go("-1");
    });
    $("#promoBar .slide-next").click(function () {
      splide.go("+1");
    });
  }

  // 3 columns, phones only.
  // Looping allows more than 1 instance per page

  var elms = $(".noDesktop3cols .splide");
  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      destroy: true,
      autoplay: true,
      type: "loop",
      perPage: 3,
      perMove: 3,
      trimSpace: false,
      interval: 5000,
      breakpoints: {
        990: {
          perPage: 2,
          perMove: 2,
        },
        767: {
          perPage: 1,
          perMove: 1,
        },
      },
      classes: {
        arrows: "splide__arrows",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev",
        next: "splide__arrow--next",
      },
    }).mount();
  }

  // 3 columns, all media.

  if ($(".allMedia3cols .splide").length) {
    new Splide(".allMedia3cols .splide", {
      autoplay: true,
      type: "loop",
      perPage: 3,
      perMove: 3,
      trimSpace: false,
      interval: 5000,
      breakpoints: {
        990: {
          perPage: 2,
          perMove: 2,
        },
        767: {
          perPage: 1,
          perMove: 1,
        },
      },
      classes: {
        arrows: "splide__arrows",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev",
        next: "splide__arrow--next",
      },
    }).mount();
  }

  // 4 columns, all media.
  // B2B landing Logos, index, product_hdm bundles

  if ($(".allMedia4cols .splide").length) {
    new Splide(".allMedia4cols .splide", {
      autoplay: false,
      type: "loop",
      perPage: 4,
      perMove: 2,
      pagination: false,
      trimSpace: false,
      interval: 5000,
      breakpoints: {
        1259: {
          perPage: 3,
          perMove: 3,
        },
        990: {
          perPage: 2,
          perMove: 2,
          pagination: true,
        },
        767: {
          perPage: 1,
          perMove: 1,
          pagination: true,
        },
      },
      classes: {
        arrows: "splide__arrows",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev",
        next: "splide__arrow--next",
      },
    }).mount();
  }

  // special slider for supplements_overview_hdm page
  // cards with nutrition info icons

  if ($("#dietarySupplements .splide").length) {
    new Splide("#dietarySupplements .splide", {
      autoplay: false,
      focus: "center",
      type: "loop",
      perPage: 7,
      perMove: 7,
      trimSpace: false,
      pagination: true,
      width: "100%",
      start: 3,
      breakpoints: {
        1259: {
          perPage: 5,
          perMove: 5,
          pagination: true,
        },
        990: {
          focus: 1,
          perPage: 4,
          perMove: 4,
          pagination: true,
        },
        767: {
          pagination: false,
          focus: 0,
          perPage: 2,
          perMove: 2,
        },
      },
      classes: {
        arrows: "splide__arrows",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev",
        next: "splide__arrow--next",
      },
    }).mount();
  }

  // special slider for product_hdm page
  // product image gallery

  if ($("#prodImages .splide").length) {
    new Splide("#prodImages .splide", {
      destroy: true,
      autoplay: true,
      type: "loop",
      perPage: 1,
      perMove: 1,
      trimSpace: false,
      interval: 5000,
      arrows: false,
      pagination: false,
      breakpoints: {
        576: {
          perPage: 1,
          perMove: 1,
        },
      },
    }).mount();
  }

  // 5 columns, phones only.
  // index page

  if ($("#noDesktop5cols .splide").length) {
    new Splide("#noDesktop5cols .splide", {
      destroy: true,
      autoplay: true,
      type: "loop",
      perPage: 1,
      perMove: 1,
      trimSpace: false,
      interval: 5000,
      pagination: false,
      breakpoints: {
        990: {
          perPage: 2,
          perMove: 2,
        },
      },
      classes: {
        arrows: "splide__arrows",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev",
        next: "splide__arrow--next",
      },
    }).mount();
  }

  $(".search-open-link").click(function () {
    if ($(".header-main").hasClass("search-open")) {
      $(".header-main").removeClass("search-open");
    } else {
      $(".header-main").addClass("search-open");
    }
  });

  if ($("#scrollTop").length) {
    scrollTopButtton = document.getElementById("scrollTop");
    var scrollFunc = function () {
      var y = window.scrollY;
      if (y >= 4320) {
        scrollTopButtton.classList.remove("d-none");
      } else {
        scrollTopButtton.classList.add("d-none");
      }
    };
    scrollFunc();
    window.addEventListener("scroll", scrollFunc);
  }

  $(".fit-height-cards").each(function () {
    var minh = 0;
    $(this)
      .find(".card-content-text-top")
      .each(function () {
        if ($(this).height() >= minh) {
          minh = $(this).height();
        }
      });
    $(this).find(".card-content-text-top").css("min-height", minh);
  });

  $(".footer-links-title").click(function () {
    if ($(this).parent().hasClass("opened")) {
      $(this).parent().removeClass("opened");
    } else {
      $(this).parent().addClass("opened");
    }
  });

  $(".tab-accordion-position-title").on("click", function () {
    if ($(this).parent().hasClass("opened")) {
      $(this).parent().removeClass("opened");
      $(this).next(".tab-accordion-position-content").slideUp();
    } else {
      $(this).parent().addClass("opened");
      $(this).next(".tab-accordion-position-content").slideDown();
    }
  });

  $(document).on("click", ".accordion-position-title", function () {
    if ($(this).parent().hasClass("opened")) {
      $(this).parent().removeClass("opened");
      $(this).next(".accordion-position-content").slideUp();
    } else {
      $(this).parent().addClass("opened");
      $(this).next(".accordion-position-content").slideDown();
    }
  });

  function furtherBtn() {
    if ($("#further-test").hasClass("active")) {
      $(".further-btn").removeClass("disabled");
      $("#further-btn-test").removeClass("d-none");
      $("#further-btn-coach").addClass("d-none");
    }
    if ($("#further-coach").hasClass("active")) {
      $(".further-btn").removeClass("disabled");
      $("#further-btn-test").addClass("d-none");
      $("#further-btn-coach").removeClass("d-none");
    }
  }

  furtherBtn();
  $(".checkboxes-btn").click(function () {
    $(this)
      .parents(".checkboxes-btns")
      .find(".checkboxes-btn")
      .removeClass("active");
    $(this).addClass("active");
    furtherBtn();
  });

  function mainImage() {
    $(".product-big-image img").attr(
      "src",
      $(".product-images-previews .active").attr("data-img")
    );
    $(".product-big-image img").attr(
      "data-link",
      $(".product-images-previews .active img").attr("data-link")
    );
  }
  $(".product-images-previews li:first-child").addClass("active");
  mainImage();
  $(".product-images-previews li").click(function () {
    $(".product-images-previews li").removeClass("active");
    $(this).addClass("active");
    mainImage();
  });

  // Product page image popup
  function closeImagePopup() {
    $("#closeImagePopup").click(function(){$("#imagePopupBlocker").remove()})
    $("#imagePopupBlocker").click(function(e){
      var container = $("#imagePopup");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $("#imagePopupBlocker").remove()
      }
    })
  }
  $(".product-big-image img").click(function() {
    let imageLink = $(this).attr("data-link")
    $(this).after(`<div class="blocker current" id="imagePopupBlocker">
    <div class="modal" id="imagePopup" style="display:inline-block;max-width: 800px;height: 800px;">
    <img id="imageInPopup" src="${imageLink}">    
    <a id="closeImagePopup" class="close-modal">Close</a></div></div>
    `);
    closeImagePopup()
  });


  if ($(".input-spinner").length) {
    $(".input-spinner input").inputSpinner();
  }

  if ($(".select").length) {
    $(".select").select2({
      minimumResultsForSearch: Infinity,
    });
  }

  $(".header-menu-title .submenu-toggle").click(function () {
    var liParent = $(this).parent(".header-menu-title").parent();
    if (liParent.hasClass("opened")) {
      liParent.removeClass("opened");
      $(this).removeClass("submenu-toggle-opened");
    } else {
      liParent.addClass("opened");
      $(this).addClass("submenu-toggle-opened");
    }
  });

  $("#menu-opener").click(function () {
    if ($(".header-menu-wrap").hasClass("mobile-opened")) {
      $(".header-menu-wrap").slideUp().removeClass("mobile-opened");
    } else {
      $(".header-menu-wrap").slideDown().addClass("mobile-opened");
    }
  });

  $(".submenu .submenu-title").click(function () {
    var liParent = $(this).parent();
    if (liParent.hasClass("submenu-item-opened")) {
      liParent.removeClass("submenu-item-opened");
      $(this).removeClass("submenu-toggle-opened");
    } else {
      liParent.addClass("submenu-item-opened");
      $(this).addClass("submenu-toggle-opened");
    }
  });

  $(".scroll").on("click", function (e) {
    e.preventDefault();
    var targetEle = this.hash;
    setTimeout(function () {
      var $targetEle = $(targetEle);
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $targetEle.offset().top - $(".header").height() - 20,
          },
          800
        );
    }, 200);
  });

  $(".fixed-menu-link").click(function () {
    var parenting = $(this).parents(".fixed-menu-wrap");
    if (parenting.hasClass("opened")) {
      parenting.removeClass("opened");
    } else {
      parenting.addClass("opened");
    }
  });

  var lastScrollTop = 0;
  $(window).scroll(function (event) {
    var st = $(this).scrollTop();
    if (st > 200) {
      $(".header-top, .header-phone").addClass("slideup");
      if (st > lastScrollTop) {
        $(".header-menu-wrap").addClass("slideup");
      } else {
        $(".header-menu-wrap").removeClass("slideup");
      }
      lastScrollTop = st;
    } else {
      $(".header-top, .header-phone").removeClass("slideup");
      $(".header-menu-wrap").removeClass("slideup");
    }
  });

  // review collapse - expand
  $(".feedbacks-position").each(function () {
    var s = $(this).find(".feedbacks-text");
    s.height() > 130 &&
      ($(this).addClass("cutoff"),
      $(this).find(".feedbacks-actions").removeClass("d-none"));
  });
  $(".feedbacks-actions a").click(function () {
    $(this).parents(".feedbacks-position").hasClass("cutoff")
      ? $(this).parents(".feedbacks-position").removeClass("cutoff")
      : $(this).parents(".feedbacks-position").addClass("cutoff");
  });

  $(".aside-menu-toggle, .menu_toggle").on("click", function () {
    var parentLi = $(this).parents(".aside-menu-title").parent();
    if (parentLi.hasClass("opened")) {
      parentLi.removeClass("opened");
    } else {
      parentLi.addClass("opened");
    }
  });

  $("[role='tablist'] .nav-link").click(function () {
    $(this)
      .parents("[role='tablist']")
      .find("[role='tab']")
      .removeClass("active");
    $(this).addClass("active");
    $(this)
      .parents("[role='tablist']")
      .next(".tab-content")
      .find("[role='tabpanel']")
      .removeClass("show")
      .removeClass("active");
    $($(this).attr("data-bs-target")).addClass("show").addClass("active");
  });
  $(".card-content .tags").each(function () {
    if ($(this).find(".all-tags h5").length < 1) {
      $(this).closest(".col-md-6").hide();
    }
  });

  // Getting access to the tabs
  if (window.location.hash) {
    let wndHash = window.location.hash;
    let tab = wndHash + "-tab";
    if($(tab).length > 0) {
      // if hash exist on doc ready then remove class "active" from all tabs        
      $("#tabs button").removeClass('active');
      $("#tabsContent .tab-pane").removeClass('show active')
      $(tab).addClass("active");
      $(wndHash).addClass('show active')
      // mobile trigger
      $(wndHash).find('.tab-accordion-position-title').trigger('click');
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }
  }

  //   Faq Section JS
  var faq = ".accordion-position";
  $(faq).each(function () {
    $(this).find("h2, h3").addClass("accordion-position-title mb-0");
    var text = $(this).find("p, ul");
    $(this).find(".accordion-position-content").append(text);
  });

  // Newsletter tooltip
  $(".newsletter-footer_card").mouseenter(function () {
    $(".newsletter-footer_tooltip").removeClass("d-none").addClass("d-block");
  });
  $(".newsletter-footer_card").mouseleave(function () {
    $(".newsletter-footer_tooltip").removeClass("d-block").addClass("d-none");
  });
});